import type { MenuDayItemDto } from '@core/interfaces/api';

function sanitizeMenuItems(items?: MenuDayItemDto[] | null): MenuDayItemDto[] {
  if (!items) return [];
  return items.filter((item) => {
    const name = item.RecipeName?.trim() ?? '';
    return name.length > 0 && !/^\*+$/.test(name);
  });
}

const CATEGORY_ORDER = [
  'Entree',
  'Entrée',
  'Main',
  'Side',
  'Bread',
  'Appetizer',
  'Condiments',
  'Beverage',
  'Dessert',
  'Salad',
  'Vegetable',
  'Soup',
];

function groupItemsByCategory(
  items: MenuDayItemDto[],
): Record<string, MenuDayItemDto[]> {
  return items.reduce<Record<string, MenuDayItemDto[]>>((acc, item) => {
    const category = item.MenuCategory?.trim() || 'Other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});
}

function sortCategories(categories: string[]): string[] {
  return categories.sort((a, b) => {
    const indexA = CATEGORY_ORDER.indexOf(a);
    const indexB = CATEGORY_ORDER.indexOf(b);
    const safeA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
    const safeB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
    return safeA - safeB || a.localeCompare(b);
  });
}

export { sanitizeMenuItems, groupItemsByCategory, sortCategories };
